import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import UploadOnboarding from "@/features/onboarding/components/UploadUI";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import { X } from "lucide-react";

const UploadFilesModal = ({ uploadModalOpen, UploadModalClose }) => {
  return (
    <CustomModal isOpen={uploadModalOpen} onClose={UploadModalClose}>
      <div className="flex flex-col gap-6 w-full">
        <div className="flex flex-col gap-4">
          <div className="flex justify-between items-center">
            <h3 className="font-semibold text-base text-gray-800">
              Upload and attach files
            </h3>
            <button className="p-1 hover:bg-gray-100 rounded-full" onClick={UploadModalClose}>
              <X size={20} color="#181D27" />
            </button>
          </div>
          <p className="text-xs text-gray-600">
            Upload and attach files to this project.
          </p>
          <UploadOnboarding />
        </div>

        {/* buttons */}
        <div className="flex gap-2 w-full">
          <SecondaryButton
            title={"Cancel"}
            className="w-full"
            onClick={UploadModalClose}
          />
          <PrimaryButton startContent={false} className="w-full">
            Attach Files
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default UploadFilesModal;
